/* eslint-disable @next/next/no-css-tags */
import Head from "next/head"
import { LayoutProps } from "../../../../design/common/Layouts"
import { useLayoutData } from "../../../../utils/contexts/LayoutContext"
import Navbar from "./_layouts/Navbar/Navbar"
import { useEffect, useState } from "react"
import { LoadingScreenStyle, colorSetter } from "../../PartnerPortalLayout"
import { Box, CircularProgress } from "@mui/material"
import { CastroJS } from "./Castro"


const CastroLayout = ({ children }: LayoutProps) => {
  const { partnerSiteFull } = useLayoutData()
  const [mainColor, setMainColor] = useState<string>("#f4511e")
  const [titleColor, setTitleColor] = useState<string>("#000000")
  const [headerInfoColor, setHeaderInfoColor] = useState<string>("#000000")
  const [menuTextColor, setMenuTextColor] = useState<string>("#fff")

  const setColors = () => {
    setMainColor(prevMainColor => {
      return colorSetter(partnerSiteFull, "mainColor") ?? prevMainColor
    })
    setTitleColor(prevTitleColor => {
      return colorSetter(partnerSiteFull, "titleColor") ?? prevTitleColor
    })
    setHeaderInfoColor(prevHeaderInfoColor => {
      return colorSetter(partnerSiteFull, "headerInfoColor") ?? prevHeaderInfoColor
    })
    setMenuTextColor(prevMenuTextColor => {
      return colorSetter(partnerSiteFull, "menuTextColor") ?? prevMenuTextColor
    })
  }

  useEffect(() => {
    CastroJS.init()
  }, [])

  useEffect(() => {
    setColors()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [partnerSiteFull])

  return (
    <>
      <Head>
        <style>
          {`
            :root {
              --main-color: ${mainColor};
              --title-color: ${titleColor};
              --header-info-color: ${headerInfoColor};
              --menu-text-color: ${menuTextColor};
            }
          `}
        </style>
        <link rel="stylesheet" type="text/css" href="/templates/CastroTemplate/assets/css/style.min.css"></link>
      </Head>

      <Box id="layout-loader" sx={LoadingScreenStyle}>
        <CircularProgress color="inherit" />
      </Box>

      <Navbar />
      {children}
    </>
  )
}

export default CastroLayout